// extracted by mini-css-extract-plugin
export default {"scrollup":"ScrollUpBtn_scrollup__PBSc+"};